import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Alert, AlertDescription } from '../components/ui/alert';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '../components/ui/card';
import { PAGE_ROOT } from '../components/work/page-chrome';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMsg(null);
    setFailed(false);
    const res = await fetch('/api/auth/request-reset', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    if (res.ok) {
      setMsg('If the email exists, a reset link was sent or logged.');
    } else {
      setFailed(true);
      setMsg('Request failed');
    }
  }

  return (
    <div className={PAGE_ROOT}>
      <main className="flex justify-center px-4 py-16">
        <Card className="w-full max-w-sm">
          <CardHeader>
            <CardTitle>Forgot password</CardTitle>
            <CardDescription>We will email a reset link if the account exists.</CardDescription>
          </CardHeader>
          <CardContent>
            <form className="space-y-4" onSubmit={submit}>
              <div className="grid gap-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              {msg ? (
                <Alert variant={failed ? 'destructive' : 'default'}>
                  <AlertDescription>{msg}</AlertDescription>
                </Alert>
              ) : null}
              <Button type="submit" className="w-full">
                Send reset link
              </Button>
            </form>
          </CardContent>
          <CardFooter>
            <Button asChild variant="link" className="h-auto p-0">
              <Link to="/login">Back to sign in</Link>
            </Button>
          </CardFooter>
        </Card>
      </main>
    </div>
  );
}
